import { useState } from "react";

export function useFaleConoscoPage() {
  const [page, setPage] = useState("inicio");
  return { page, setPage };
}
